import CASL from '@/utils/constants/casl'

export default {
  path: 'app-user',
  children: [
    {
      path: '',
      name: 'app-user.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.MOBILE_APP_SETUP
      },
      component: () => import('./list/AppUserListPage.vue')
    }
  ]
}
